import { render, staticRenderFns } from "./CatalogsHome.vue?vue&type=template&id=ac777c5a&"
import script from "./CatalogsHome.vue?vue&type=script&lang=js&"
export * from "./CatalogsHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports